import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField } from "material-ui"
import strings from "../../localization/strings"
import { IJobDocument, EAddJobValidationType, IClientDocument } from "../../models"
import AccountStore from "../../stores/AccountStore"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import HierarchyItemChip from "../../components/hierarchy/HierarchyItemChip"
import ChooseClientChip from "../../components/clients/choose_client/ChooseClientChip"
import * as utils from "../../helpers/utils"
import * as api from "../../api"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"

interface IProps {
    handleClose(): void
    handleAdd(job: IJobDocument): void
}
interface IState {
    name: string
    errorName: string
    description: string
    checkingValidate: boolean
    costCode: string
    errorCostCode: string
    jobId: string
    errorJobId: string
    client: IClientDocument
}

export default class AddJobDialog extends React.Component<IProps, IState> {
    private hierarchyId = HierarchySettingsStore.getGlobalLevelItemFilterId() ? HierarchySettingsStore.getGlobalLevelItemFilterId() : null
    constructor(props: IProps) {
        super(props)
        this.state = {
            name: "",
            errorName: "",
            description: "",
            checkingValidate: false,
            costCode: "",
            errorCostCode: "",
            jobId: "",
            errorJobId: "",
            client: null
        }
        autobind(this)
    }

    getJobPayload() {
        const payload = {
            Id: utils.guid(),
            Name: this.state.name.trim(),
            Note: this.state.description,
            HierarchyId: this.hierarchyId,
            AccountId: AccountStore.getCurrentAccount().Id,
            CostCode: this.state.costCode.trim() ? this.state.costCode.trim() : null,
            ExternalId: this.state.jobId.trim() ? this.state.jobId.trim() : null,
            UserModified: true,
            ClientId: this.state.client && this.state.client.Id,
            ClientName: this.state.client && this.state.client.Name
        } as IJobDocument
        return payload
    }

    handleSave() {
        this.checkValidate().then(res => {
            if (!res) return
            this.props.handleAdd(this.getJobPayload())
        })
    }

    checkValidate() {
        let isValidate = true
        if (!this.state.name.trim()) {
            this.setState({ errorName: strings.NameRequired })
            isValidate = false
        }
    else {
            this.setState({ errorName: "" })
        }

        return new Promise(resolve =>
            !isValidate ?
        resolve(false) :
        this.setState({ checkingValidate: true }, () =>
                      api.checkValidateJob(this.getJobPayload())
            .then(res => {
                          const result = res.data as EAddJobValidationType[]
                          this.setState({
                              checkingValidate: false,
                              errorName: result.includes(EAddJobValidationType.DuplicatedName) ? strings.Name_is_duplicated : "",
                              errorJobId: result.includes(EAddJobValidationType.DuplicatedExternalId) ? strings.Job_ID_is_duplicated : "",
                              errorCostCode: result.includes(EAddJobValidationType.DuplicatedCostCode) ? strings.Cost_Code_is_duplicated : "",
                          })
                          resolve(result.includes(EAddJobValidationType.Valid))
                      })
                  )
        )
    }

    render() {
        return (
            <Dialog
                open
                title={checkJobFieldAvailable("singular") ? `Add ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Add_Job}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton
            data-intercom-target={"menu-Jobs-Btn-CloseAddJobDialog"}
            label={strings.CANCEL}
            secondary
            onClick={this.props.handleClose}
          />,
                    <FlatButton
            data-intercom-target={"menu-Jobs-Btn-SaveJob"}
            label={strings.SAVE}
            primary
            disabled={this.state.checkingValidate}
            onClick={this.handleSave}
          />
                ]}
            >
                <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                    <div style={{ display: "flex" }}>
                        <HierarchyItemChip
              title={strings.HierarchyLevel}
              hierarchyItemId={HierarchySettingsStore.getGlobalLevelItemFilterId()}
              maxWidth={700}
            />
                        {AccountStore.getClientsEnabled() && AccountStore.getJobsEnabled() && <div style={{ marginLeft: 10 }}>
                                <ChooseClientChip handleSave={(client) => this.setState({ client })} selectedClient={this.state.client} />
                            </div>}
                    </div>
                    <TextField
                        data-intercom-target={"menu-Jobs-AddJob-Entry-Name"}
                        floatingLabelText={strings.Name}
                        value={this.state.name}
                        onChange={(e, value) => { this.setState({ name: value }, () => this.checkValidate()) }}
                        errorText={this.state.errorName}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                        fullWidth={true}
                    />
                    <TextField
                        data-intercom-target={"menu-Jobs-AddJob-Entry-Description"}
                        floatingLabelText={strings.Description}
                        value={this.state.description}
                        onChange={(e, value) => { this.setState({ description: value }) }}
                        fullWidth={true}
                    />
                    <TextField
                        data-intercom-target={"menu-Jobs-AddJob-Entry-CostCode"}
                        floatingLabelText={strings.Cost_Code}
                        value={this.state.costCode}
                        onChange={(e, value) => { this.setState({ costCode: value }, () => this.checkValidate()) }}
                        errorText={this.state.errorCostCode}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                        fullWidth={true}
                    />
                    <TextField
                        data-intercom-target={"menu-Jobs-AddJob-Entry-ExternalId"}
                        floatingLabelText={ checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} ID`: strings.Job_ID}
                        value={this.state.jobId}
                        onChange={(e, value) => this.setState({ jobId: value }, () => this.checkValidate())}
                        errorText={this.state.errorJobId}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                        fullWidth={true}
                    />
                </div>
            </Dialog>
        )
    }
}